import { render } from "./EloquentField.vue?vue&type=template&id=bc5c7490"
import script from "./EloquentField.vue?vue&type=script&lang=js"
export * from "./EloquentField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__